import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router";

import {
	Grid,
	CircularProgress,
	Typography,
	withStyles,
	Button,
	TextField,
	Fade
} from "@material-ui/core";
import classnames from "classnames";
import { auth } from "../../../store";
const { signin } = auth;

class Login extends Component {
	state = {
		login: "",
		password: "",
		name: ""
	};

	componentWillReceiveProps(nextProps) {
		if (!this.props.error && nextProps.error) {
			this.setState({ password: "" });
		}
	}

	handleTabChange = (e, id) => {
		this.props.setActiveTabId(id);
	};

	handleInput = (e, input = "login") => {
		if (this.props.error) {
			this.props.resetError();
		}

		if (input === "login") {
			this.setState({ login: e.target.value });
		} else if (input === "password") {
			this.setState({ password: e.target.value });
		} else if (input === "name") {
			this.setState({ name: e.target.value });
		}
	};

	handleLoginButtonClick = () => {
		this.props.signin(this.state.login, this.state.password);
	};

	render() {
		const { classes } = this.props;
		return (
			<Grid container className={classes.container}>
				<div className={classes.formContainer}>
					<div className={classes.form}>
						<Typography variant="h1" className={classes.errorMessage}>
							{"LOGIN"}
						</Typography>
						<Fade in={this.props.error}>
							<Typography color="secondary" className={classes.errorMessage}>
								{"Wrong login or password."}
							</Typography>
						</Fade>
						<TextField
							id="email"
							InputProps={{
								classes: {
									underline: classes.textFieldUnderline,
									input: classes.textField
								}
							}}
							value={this.state.login}
							onChange={e => this.handleInput(e, "login")}
							margin="normal"
							placeholder="Email Adress"
							type="email"
							fullWidth
						/>
						<TextField
							id="password"
							InputProps={{
								classes: {
									underline: classes.textFieldUnderline,
									input: classes.textField
								}
							}}
							value={this.state.password}
							onChange={e => this.handleInput(e, "password")}
							margin="normal"
							placeholder="Password"
							type="password"
							fullWidth
						/>
						<div className={classes.formButtons}>
							{this.props.isLoading ? (
								<CircularProgress size={26} className={classes.loginLoader} />
							) : (
								<Button
									disabled={
										this.state.login.length === 0 ||
										this.state.password.length === 0
									}
									onClick={this.handleLoginButtonClick}
									variant="contained"
									color="primary"
									size="large"
								>
									{"Login"}
								</Button>
							)}
							<Button
								color="primary"
								size="large"
								className={classes.forgetButton}
							>
								{"Forget Password"}
							</Button>
						</div>
					</div>
				</div>
			</Grid>
		);
	}
}

const styles = theme => ({
	container: {
		height: "100vh",
		width: "100vw",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		position: "absolute",
		top: 0,
		left: 0
	},
	formContainer: {
		width: "40%",
		height: "100%",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		[theme.breakpoints.down("md")]: {
			width: "50%"
		}
	},
	form: {
		width: 320
	},
	tab: {
		fontWeight: 400,
		fontSize: 18
	},
	greeting: {
		fontWeight: 500,
		textAlign: "center",
		marginTop: theme.spacing.unit * 4
	},
	subGreeting: {
		fontWeight: 500,
		textAlign: "center",
		marginTop: theme.spacing.unit * 2
	},
	googleButton: {
		marginTop: theme.spacing.unit * 6,
		// boxShadow: theme.customShadows.widget,
		backgroundColor: "white",
		width: "100%",
		textTransform: "none"
	},
	googleButtonCreating: {
		marginTop: 0
	},
	googleIcon: {
		width: 30,
		marginRight: theme.spacing.unit * 2
	},
	creatingButtonContainer: {
		marginTop: theme.spacing.unit * 2.5,
		height: 46,
		display: "flex",
		justifyContent: "center",
		alignItems: "center"
	},
	createAccountButton: {
		height: 46,
		textTransform: "none"
	},
	formDividerContainer: {
		marginTop: theme.spacing.unit * 4,
		marginBottom: theme.spacing.unit * 4,
		display: "flex",
		alignItems: "center"
	},
	formDividerWord: {
		paddingLeft: theme.spacing.unit * 2,
		paddingRight: theme.spacing.unit * 2
	},
	formDivider: {
		flexGrow: 1,
		height: 1,
		backgroundColor: `${theme.palette.text.hint}40`
	},
	errorMessage: {
		textAlign: "center"
	},
	textFieldUnderline: {
		"&:before": {
			borderBottomColor: theme.palette.primary.light
		},
		"&:after": {
			borderBottomColor: theme.palette.primary.main
		},
		"&:hover:before": {
			borderBottomColor: `${theme.palette.primary.light} !important`
		}
	},
	textField: {
		borderBottomColor: theme.palette.background.light
	},
	formButtons: {
		width: "100%",
		marginTop: theme.spacing.unit * 4,
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center"
	},
	forgetButton: {
		textTransform: "none",
		fontWeight: 400
	},
	loginLoader: {
		marginLeft: theme.spacing.unit * 4
	},
	copyright: {
		marginTop: theme.spacing.unit * 4,
		whiteSpace: "nowrap",
		[theme.breakpoints.up("md")]: {
			position: "absolute",
			bottom: theme.spacing.unit * 2
		}
	}
});

const mapStateToProps = state => ({
	...state.helpers,
	...state.auth,
	filters: state.filters
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			signin
		},
		dispatch
	);

Login.propTypes = {};

export default withStyles(styles)(
	withRouter(
		connect(
			mapStateToProps,
			mapDispatchToProps
		)(Login)
	)
);
